import { useState } from "react";
import ExpansionBlueprintModal from "@/components/ExpansionBlueprintModal";
import {
  PokeballIcon,
  YugiohCardIcon,
  DragonBallStarIcon,
} from "@/components/TCGIcons";

/**
 * NextDropBanner — desktop-sidebar teaser for FiguMatch's post-World-Cup
 * expansion into Pokémon TCG / Yu-Gi-Oh! / Dragon Ball. Hidden on mobile.
 * Purely presentational — no API calls, no auth-aware state.
 */
export default function NextDropBanner() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      {/* Outer wrapper carries the 1px animated gradient border */}
      <div
        data-testid="nextdrop-banner"
        className="nextdrop-banner-wrapper mt-4"
      >
        <div className="nextdrop-banner-inner">
          {/* Top row — badge + micro card-shift SVG */}
          <div className="flex items-center justify-between">
            <span className="nextdrop-badge">COMING SOON 🃏</span>
            <ShiftingCardsIcon />
          </div>

          {/* Title */}
          <h3 className="text-white font-display font-bold text-[15px] mt-2.5 leading-tight">
            Beyond Football…
          </h3>

          {/* Body */}
          <p className="text-[#a1a1aa] font-body text-[12px] leading-[1.5] mt-1.5 mb-2.5">
            The World Cup is just the beginning. FiguMatch is evolving.
            Post-tournament, the platform transitions into the ultimate
            automated trading hub for Pokémon, Yu-Gi-Oh!, and Dragon Ball
            TCG and collectibles. A highly scalable, 24/7 global
            marketplace.
          </p>

          {/* Icon row */}
          <div className="flex items-center justify-around gap-2 mt-1 mb-2">
            <span className="inline-flex items-center justify-center w-10 h-10 shrink-0">
              <PokeballIcon className="w-7 h-7" />
            </span>
            <span className="inline-flex items-center justify-center w-10 h-10 shrink-0">
              <YugiohCardIcon className="w-7 h-7" />
            </span>
            <span className="inline-flex items-center justify-center w-10 h-10 shrink-0">
              <DragonBallStarIcon className="w-7 h-7" />
            </span>
          </div>

          {/* CTA */}
          <button
            type="button"
            data-testid="nextdrop-cta"
            onClick={() => setModalOpen(true)}
            className="nextdrop-cta mt-2.5 w-full"
          >
            View Expansion Blueprint
          </button>
        </div>
      </div>

      <ExpansionBlueprintModal
        open={modalOpen}
        onOpenChange={setModalOpen}
      />
    </>
  );
}

function ShiftingCardsIcon() {
  return (
    <svg
      viewBox="0 0 24 20"
      width="24"
      height="20"
      aria-hidden="true"
      focusable="false"
      style={{ pointerEvents: "none" }}
    >
      {/* 3 stacked mini-cards with subtle offsets — animated via keyframes */}
      <rect
        x="2"
        y="3"
        width="10"
        height="14"
        rx="1.5"
        fill="#3b82f6"
        opacity="0.55"
        className="nextdrop-shift-a"
      />
      <rect
        x="7"
        y="3"
        width="10"
        height="14"
        rx="1.5"
        fill="#7c3aed"
        opacity="0.7"
        className="nextdrop-shift-b"
      />
      <rect
        x="12"
        y="3"
        width="10"
        height="14"
        rx="1.5"
        fill="#a78bfa"
        opacity="0.85"
        className="nextdrop-shift-c"
      />
    </svg>
  );
}
